import React from 'react';
import * as S from './styled';

const ProgressBar = ({ total, current, ...rest }) => (
  <S.ProgressBar value={current} max={total} {...rest} />
);

export default ProgressBar;
